import template from './app.html';
import controller from './app.controller';
import './common/ui/account-number/accountNumber';
import './common/ui/addSecurities/addSecurities';
import './common/ui/appHeader/appHeader';
import './common/ui/faq/faq';
import './common/ui/appFooter/appFooter';
import './common/ui/sellFragments/sellFragments';
import './common/ui/infoCheckbox/infoCheckbox';
import './common/ui/oldBankInput/oldBankInput';
import './common/ui/positions/positions';
import './common/ui/positionsTable/positionsTable';
import './common/ui/progressBar/progressBar';
import './common/ui/stockList/stockList';
import './common/ui/toggleControl/toggleControl';
import './common/ui/loadingOverlay/loadingOverlay';
import './common/ui/pdfViewer/pdfViewer';

export const appComponent = {
  name: 'app',
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    languageOptions: '<',
  },
};



// WEBPACK FOOTER //
// ./src/app/app.component.js